module.exports = __webpack_public_path__ + "img/pethouse37.aeede14e.jpg";